import { routeById, type MiraRouteId } from '@mira/clients-shared';

export function hrefForRoute(routeId: MiraRouteId, params: Record<string, string> = {}, query: Record<string, string> = {}): string {
  let path = routeById(routeId).path;
  for (const [key, value] of Object.entries(params)) {
    path = path.replace(`:${key}`, encodeURIComponent(value));
  }
  if (path.includes(':')) path = path.replace(/:[^/]+/gu, 'new');
  const search = new URLSearchParams(query).toString();
  return `#${path}${search ? `?${search}` : ''}`;
}

export function navigateTo(routeId: MiraRouteId, params: Record<string, string> = {}, query: Record<string, string> = {}): void {
  window.location.hash = hrefForRoute(routeId, params, query).slice(1);
}

export function replaceRoute(routeId: MiraRouteId, params: Record<string, string> = {}, query: Record<string, string> = {}): void {
  const href = hrefForRoute(routeId, params, query);
  window.history.replaceState(null, '', href);
  window.dispatchEvent(new HashChangeEvent('hashchange'));
}
